import { useState, useEffect } from 'react';
import { API } from 'aws-amplify';
import { DashboardProduct, DashboardOffer } from '../types';

const USE_MOCK_DATA = false;

interface UseProductsAndOffersResult {
  products: DashboardProduct[];
  offers: DashboardOffer[];
  loading: boolean;
  refetch: () => Promise<void>;
}

export function useProductsAndOffers(): UseProductsAndOffersResult {
  const [products, setProducts] = useState<DashboardProduct[]>([]);
  const [offers, setOffers] = useState<DashboardOffer[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchProductsAndOffers = async () => {
    setLoading(true);
    try {
      let productsData: DashboardProduct[] = [];
      let offersData: DashboardOffer[] = [];

      if (USE_MOCK_DATA) {
        // Fetch from mock files
        const [productsRes, offersRes] = await Promise.all([
          fetch('/temp/test/GetProductsForDashboard.json').then(r => r.json()),
          fetch('/temp/test/GetOffersForDashboard.json').then(r => r.json()),
        ]);
        productsData = productsRes.Products || [];
        offersData = offersRes.Offers || [];
      } else {
        // Fetch from API
        const [productsRes, offersRes] = await Promise.all([
          API.get('AE', '/Dashboard/GetProductsForDashboard', { response: true }),
          API.get('AE', '/Dashboard/GetOffersForDashboard', { response: true }),
        ]);
        productsData = productsRes.data.Products || [];
        offersData = offersRes.data.Offers || [];
      }

      setProducts(productsData);
      setOffers(offersData);
    } catch (error) {
      console.error('Error fetching products and offers:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProductsAndOffers();
  }, []);

  return {
    products,
    offers,
    loading,
    refetch: fetchProductsAndOffers,
  };
}
